<template>
  <div>
    <div>
      <Titulo :titulo="'Informes - ' + routeName" />
    </div>
    <!-- coger el parametro que se envio por la ruta -->
    <!-- {{$route.params.id}} -->
    <div class="margin-informes">
      <br />
      <!--
        @props
            data: Array,            required: true
            pagination: boolean,    required: false
            perPage: Number,        required: false
            SetectFiltro: Array     required: false
            filtro: boolean         required: false
      -->
      <table-component
        :data="data"
        @click-buscar="buscar"
        @click-event="clickEvent"
        filtro
        showExportToExcel
        :perPage="perPage"
        :dataLength="dataLength"
      >
        <table-column slot="label" :label="'Convenio'" v-bind:value="'convenio'" customClass="text-center"></table-column>
        <table-column slot="label" :label="'Fecha de Pago'" v-bind:value="'fecha_limite_pago'" customClass="text-center"></table-column>
        <table-column slot="label" :label="'Valor Total'" v-bind:value="'total'" customClass="text-center" :filter="'numberFormat'"></table-column>
        <table-column slot="label" :label="'Estado'" v-bind:value="'estado'" customClass="text-center"></table-column>
        <table-column slot="label" :icon="'fa'" :customClass="'text-center'">
          <table-column
            slot="icon"
            :icon="'fa fa-file-text'"
            :class="'btn btn-sm btn-info'"
            :slug="'export-to-excel'"
            :tooltip="'Exportar Excel'"
          ></table-column>
        </table-column>
      </table-component>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import SelectNovedad from "@/data/SelectQueEsNovedad.json";
import SelectTipoNovedad from "@/data/SelectTipoNovedad.json";

import XLSX from "xlsx";
import { saveAs } from "file-saver";

export default {
  name: "SubirInformes",
  data() {
    return {
      SelectNovedad: SelectNovedad,
      SelectTipoNovedad: SelectTipoNovedad,
      selectQueEsNovedad: "",
      selectTipoNovedad: "",
      perPage: 10,
      informe_url: "portal/informes/tramite_pago/",
      fileName: "En Tramite de Pago ",
    };
  },
  components: {
    Titulo: () => import("@/containers/layout/Titulo.vue"),
    TableComponent: () => import("@/components/table/TableComponent"),
    TableColumn: () => import("@/components/table/TableColumn"),
  },
  computed: {
    ...mapGetters({
      TablaVerProducto: "pages/TablaVerProducto",
      SelectFiltroTabla: "pages/SelectFiltroTabla",
      loading: "loading",
    }),
    dataLength() {
      return this.$store.getters["pages/total"];
    },
    data() {
      return this.$store.getters["pages/dataInformes"];
    },
    routeName() {
      return this.$router.currentRoute.name;
    },
  },
  methods: {
    buscar(event) {
      this.fecha_inicio = event.fecha_inicio;
      this.fecha_fin = event.fecha_fin;
      this.convenio = event.convenio;
      this.perPage = event.nRows;
      this.loadData();
    },
    async clickEvent(event, slug) {
      switch (slug) {
        case "paginacion":
          this.perPage = event.nRows;
          this.loadData(data.nRows, data.page);
          break;
        case "export-to-excel":
          this.$toasted.show("Por favor espere mientras exportamos los datos", {
            theme: "toasted-primary",
            position: "top-center",
            duration: 5000,
          });
          this.$store.commit("SET_LOADING", true);
          try {
            let result = await this.$store.state.api.post("portal/informes/tramite_pago/exportar" ,{
              convenio: event.convenio, estado_reclamacion: event.estado_reclamacion
            });
            let data = XLSX.utils.json_to_sheet(result.data.datos, {
              header: [
                "cedula",
                "nombre",
                "pagare",
                "total_liquidacion"
              ],
            });

            data["A1"].v = "Documento";
            data["B1"].v = "Nombre";
            data["C1"].v = "Pagaré";
            data["D1"].v = "Total Liquidación";

            var workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, data, this.fileName);
            var wopts = { bookType: "xlsx", bookSST: false, type: "array" };
            var wbout = XLSX.write(workbook, wopts);
            var today = new Date();
            var dd = today.getDate();

            var mm = today.getMonth() + 1;
            var yyyy = today.getFullYear();

            if (dd < 10) {
              dd = "0" + dd;
            }

            if (mm < 10) {
              mm = "0" + mm;
            }

            today = dd + "/" + mm + "/" + yyyy;
            saveAs(
              new Blob([wbout], { type: "application/octet-stream" }),
              this.fileName + today + ".xlsx"
            );
            this.$toasted.show("El archivo fue exportado exitosamente", {
              theme: "toasted-primary",
              position: "top-right",
              duration: 10000,
            });
          } catch (err) {
            this.$toasted.show(
              "Ocurrió un error al intentar exportar el archivo",
              {
                theme: "toasted-primary",
                position: "top-right",
                duration: 10000,
              }
            );
          }
          this.$store.commit("SET_LOADING", false);
          break;
      }
    },
    loadData() {
      this.$store.dispatch("pages/fetch", {
        endpoint: this.informe_url,
        params: {
          convenio: this.convenio,
          fecha_inicio: this.fecha_inicio,
          fecha_fin: this.fecha_fin,
          row: this.perPage,
        },
      });
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>